// extracted by mini-css-extract-plugin
module.exports = {"wrap_logo":"sidebarlayout_wrap_logo__1xpW8","logo":"sidebarlayout_logo__2KN_j","sidebar":"sidebarlayout_sidebar__1blLX","sidebar_title":"sidebarlayout_sidebar_title__2q3NA"};